module.exports = __webpack_public_path__ + "media/images/products/category/sm/6-808f3287f4bd5ff2bf97521a531c4c04.jpg";